import { render, staticRenderFns } from "./BusinessMenuList.vue?vue&type=template&id=346ffda2&scoped=true&"
import script from "./BusinessMenuList.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuList.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuList.vue?vue&type=style&index=0&id=346ffda2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ffda2",
  null
  
)

export default component.exports